import {InputProps, InputStyle, LabelStyle, Wrapper} from './input.style';
import React, {forwardRef, ReactNode} from 'react';

export interface InputComponentProps extends InputProps, React.InputHTMLAttributes<HTMLInputElement> {
    label?: string | ReactNode;
    message?: string;
    icon?: ReactNode;
    wrapperClassName?: string
}

export const InputComponent = forwardRef<HTMLInputElement, InputComponentProps>(({
                                                                                     message,
                                                                                     label,
                                                                                     icon,
                                                                                     $iconPosition = 'start',
                                                                                     wrapperClassName,
                                                                                     className,
                                                                                     ...props
                                                                                 }, ref) => {
    return <Wrapper className={`rb-input ${wrapperClassName || ""}`} $error={props.$error} $hasIcon={!!icon}
                    $iconPosition={$iconPosition}
                    $success={props.$success}>
        {(label || message) && <div className={'input-title shrink-0 gap-x-3'}>
            {label &&
                <LabelStyle className={"flex-shrink-0 rb-label"} htmlFor={props.id || ''}>{label}</LabelStyle>
            }
            {message &&
                <span className={'message'}>{message}</span>
            }
        </div>}
        <div className={'input-container'}>
            {(icon && $iconPosition === 'start') && <div className={'icon'}>
                {icon}
            </div>}
            <InputStyle className={`grotesk-fnt ${className || ""}`} ref={ref} $iconPosition={$iconPosition}
                        $hasIcon={!!icon} {...props} />
            {(icon && $iconPosition === 'end') && <div className={'icon'}>
                {icon}
            </div>}
        </div>
    </Wrapper>;
});
InputComponent.displayName = "InputComponent"